import type { ReactNode } from 'react'

export function ConfirmBox({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className="bg-[var(--fl-surface)] rounded-xl shadow-[0_8px_40px_rgba(0,0,0,0.12)] w-full max-w-sm mx-4 p-6"
      >
        <h3 className="font-semibold text-[var(--fl-text-1)] mb-2">{title}</h3>
        {children}
      </div>
    </div>
  )
}
